export const AUTH_SESSION_UPDATED_EVENT = 'authSessionUpdated'
export const AUTH_SESSION_CLEARED_EVENT = 'authSessionCleared'
